<template>
	<div>
		<v-data-table
			hide-default-header
			:items="dataSource"
			:headers="colunas"
			:server-items-length="totalItens"
			item-key="id"
			v-if="hasItens"
			hide-default-footer
			:options="paginacaoInterna"
		>
			<template #body="{ items }">
				<div class="py-2">
					<collapse-para-listagem :items="items">
						<template #collapse-header="{ item }">
							{{ item.numeroAta }}
							<icone-simples-redondo-com-label
								v-if="item.numeroAdesoesParaAnalise > 0"
								:texto="textoPossuiAdesao(item.numeroAdesoesParaAnalise.toString())"
								cor-background="orange"
								:label-botao="item.numeroAdesoesParaAnalise.toString()"
							></icone-simples-redondo-com-label>
						</template>
						<template #collapse-content="{ item }">
							<listagem-adesoes-interna-collapses
								:id-ata="item.idAta"
							></listagem-adesoes-interna-collapses>
						</template>
					</collapse-para-listagem>
				</div>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
		<template-listagem-vazia v-else :textos="textos"></template-listagem-vazia>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import ListagemInternaSelecionados from '@/views/pages/ata/gerar-ata/com-processo/modal/primeira-etapa/selecionados/listagem-interna-selecionados/ListagemInternaSelecionados.vue'
import { actionTypes } from '@/core/constants'
import IconeSimplesRedondoComLabel from '@/views/components/icones/IconeSimplesRedondoComLabel.vue'
import ListagemAdesoesInternaCollapses from '@/views/pages/ata/pesquisa/listagem-collapses/listagem-adesoes/ListagemAdesoesInternaCollapses.vue'
import { mapState } from 'vuex'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import mutationTypes from '@/core/constants/mutation-types'

export default {
	name: 'listagem-adesoes-collapses',
	components: {
		TemplateListagemVazia,
		ListagemAdesoesInternaCollapses,
		IconeSimplesRedondoComLabel,
		ListagemInternaSelecionados,
	},
	data() {
		return {
			totalPaginas: 0,
			totalItens: 0,
			dataSource: [],
			textos: {
				titulo: 'Não foram encontradas atas com adesões',
			},
			paginacaoInterna: this.$store.state.ata.pesquisa.adesao.paginacao,
			colunas: [new TabelaColunaUtils('', 'numero', '100%')],
			abertos: [],
		}
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
		...mapState({
			filtros: (state) => state.ata.filtro,
		}),
	},
	watch: {
		filtros: {
			async handler() {
				await this.carregarCollapses()
			},
			deep: true,
		},
		paginacaoInterna: {
			async handler(paginacao) {
				await this.setPaginacao(paginacao)
			},
			deep: true,
		},
	},
	async mounted() {
		this.resetarPage()
		await this.carregarCollapses()
	},
	methods: {
		async carregarCollapses() {
			const retorno = await this.$store.dispatch(actionTypes.ATA.BUSCAR_ATAS_COLLAPSES_ADESOES, {
				filtro: this.filtros,
				paginacao: this.paginacaoInterna,
			})

			this.totalPaginas = retorno.totalPages
			this.totalItens = retorno.totalElements
			this.dataSource = retorno.itens
		},
		async setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ATA.PESQUISA.ADESAO.SET_PAGINACAO_PESQUISA_LISTAGEM, paginacao)
			await this.carregarCollapses()
		},
		resetarPage() {
			this.$store.commit(mutationTypes.ATA.PESQUISA.ADESAO.RESETAR_PAGINA_PESQUISA_LISTAGEM)
		},
		textoPossuiAdesao(valor) {
			return valor > 1 ? valor + ' adesões para receber.' : valor + ' adesão para receber.'
		},
	},
}
</script>
